// Vieira Whelan — theme.js
// Minimal — most behavior is co-located with sections.
document.addEventListener('DOMContentLoaded', () => {
  // Smooth-anchor fallback
  document.querySelectorAll('a[href^="#"]').forEach(a => {
    a.addEventListener('click', e => {
      const id = a.getAttribute('href').slice(1);
      const el = document.getElementById(id);
      if (el) { e.preventDefault(); el.scrollIntoView({behavior:'smooth', block:'start'}); }
    });
  });
});
